import { Space } from "antd";
import React from "react";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import {
  EditOutlined,
  EyeOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import tmsRouteMap from "../../../constants/tms-route.map";
import TmsSevasService from "../../../services/tms-sevas.service";

const TmSevasinnerActions = ({
  record,
  setLoading,
  setViewSevaData,
  settmsModalVisible,
  // eslint-disable-next-line no-unused-vars
  setUpdateFlag,
  setEditFlag,
  setProductId,
  router,
  setShowDrawer,
  setTermsData,
  setMiniTicket,
}) => {
  return (
    <Space size="middle">
      <a
        onClick={() => {
          router.navigate(
            `${tmsRouteMap.sms_sevas_manage_slots}?id=${record.key}`
          );
        }}
      >
        Manage Slot
      </a>
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const darData = await TmsSevasService.viewSeva(record?.key);
            // console.log(darData);
            setViewSevaData(darData);
            settmsModalVisible(true);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EyeOutlined />
      </a>
      {/* <Popconfirm
        title="Are you sure delete this darshanam?"
        onConfirm={async () => {
          setLoading(true);
          try {
            await TmsSevasService.deleteSeva(record?.key);
            notification.success({
              message: "Seva Deleted Successful",
            });
            setUpdateFlag(Math.Random + 1);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
        okText="Yes"
        cancelText="No"
      >
        <a>
          <DeleteOutlined />
        </a>
      </Popconfirm> */}
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const darData = await TmsSevasService.viewSeva(record?.key);
            setViewSevaData(darData);
            settmsModalVisible(true);
            setEditFlag(true);
            setProductId(record?.key);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EditOutlined />
      </a>
      <a
        onClick={() => {
          setShowDrawer(true);
          setProductId(record?.key);
          setTermsData(record?.metadata?.termsAndConditions);
          setMiniTicket(
            record.metadata?.ticketType === "mini_ticket" ? true : false
          );
        }}
      >
        <FileProtectOutlined />
      </a>
    </Space>
  );
};
export default withRouter(TmSevasinnerActions);
